import * as React from "react";
import LiveCommentsReportService from "../../../services/reports.service";
import { usePaginatedFetch } from "./usePaginatedFetch";

export function useEcoReports(args) {
  const [from, setFrom] = React.useState("");
  const [to, setTo] = React.useState("");

  const fetcher = React.useCallback(
    async (page, pageSize) => {
      const payload = await LiveCommentsReportService.getEcoReports(
        page,
        pageSize,
        from,
        to
      );

      const postReports = (payload.postReports).map((r) => ({
        ...r,
        reportType: "Post",
      }));
      const commentReports = (payload.commentReports).map((r) => ({
        ...r,
        reportType: "Comentario",
      }));

      const allReports = [...postReports, ...commentReports].sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );

      const pagination = {
        page: payload.page ?? page,
        pageSize: payload.pageSize ?? pageSize,
        totalPages: payload.totalPages ?? 1,
        totalItems:
          (payload.totalPostReports ?? 0) + (payload.totalCommentReports ?? 0),
      };

      return { data: allReports, pagination };
    },
    [from, to]
  );

  const deleteEcoPostOrCommentReport = React.useCallback(
    async (reportId, type) => {
      return await LiveCommentsReportService.deleteEcoPostOrCommentReport(
        reportId,
        type
      );
    },
    []
  );

  const base = usePaginatedFetch({
    enabled: args.enabled,
    auto: false,
    initialPage: 1,
    pageSize: 20,
    fetcher,
  });

  const reportPostDetails = React.useCallback(
    (postId) => LiveCommentsReportService.getEcoReportDetails(postId),
    []
  );

  const reportCommentDetails = React.useCallback(
    (postId) => LiveCommentsReportService.getEcoReportCommentsDetails(postId),
    []
  );

  React.useEffect(() => {
    base.resetPage();
  }, [from, to, base.resetPage]);

  const search = React.useCallback(async () => {
    await base.fetchNow();
  }, [base.fetchNow]);

  return {
    ...base,
    from,
    to,
    setFrom,
    setTo,
    search,
    reportPostDetails,
    reportCommentDetails,
    deleteEcoPostOrCommentReport,
  };
}
